export default __webpack_public_path__ + "static/media/CO.9164e90e.svg";